import TabList from './TabList'
import TabPanel from './TabPanel'
import MarksList from './MarksList'
import VideoContainer from '../containers/VideoContainer'
import findEnglishVideo from '../utils/findEnglishVideo'
import { decamelizeKeys } from 'humps'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import TranscriptView from './TranscriptView'
import { scrollOnTimeUpdateWithFeatures } from '../utils/scrollOnTimeUpdate'
import { addMark, updateMark, removeMark } from '../actions/markActions'
import { connect } from 'react-redux'
import Button from '../components/buttons/Button'
import MarkRow from './MarkRow'
import MarkAlert from './MarkAlert'
class VideoResponseMain extends Component {
  static defaultProps = {
    scrollDuration: 300
  }

  static propTypes = {
    addMark: PropTypes.func,
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    removeMark: PropTypes.func,
    response: PropTypes.object.isRequired,
    scrollDuration: PropTypes.number,
    searchHighlights: PropTypes.array,
    updateMark: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.toggleTranscript = this.toggleTranscript.bind(this)

    this.state = {
      showTranscript: true,
      marks: this.props.response.responseComments,
      addMarkRow: false,
      showError: false
    }
  }

  toggleTranscript() {
    const { showTranscript } = this.state
    this.setState({ showTranscript: !showTranscript })
  }

  getTranscript() {
    const { response, searchHighlights } = this.props
    const { showTranscript } = this.state
    let transcript
    let timestamps

    if (response.timestampRequestStatus !== 'processing') {
      transcript = response.transcript
      const videoTranscript = response.video.videoTranscript || {}
      timestamps = videoTranscript.jsonTimestamps || []
    }

    if (!transcript) {
      return (
        <span className="grey-reg-i">{I18n.t('No transcript provided')}</span>
      )
    }

    if (showTranscript) {
      return [
        <a key="transcriptLink" onClick={this.toggleTranscript}>
          {I18n.t('Hide Transcript')}
        </a>,
        <div key="transcript">
          <TranscriptView
            tokens={searchHighlights || []}
            text={transcript.trim()}
            timestamps={timestamps || []}
          />
        </div>
      ]
    }

    return <a onClick={this.toggleTranscript}>{I18n.t('Show Transcript')}</a>
  }

  handleMarkClick(mark) {
    this.video.currentTime(mark.secondsAfterStart)
  }

  handleMarkUpdate = mark => {
    const { marks } = this.state

    if (mark.text.trim()) {
      const index = marks.findIndex(m => m.id === mark.id)

      return this.props.updateMark(mark).then(() =>
        this.setState(state => ({
          marks: [
            ...state.marks.slice(0, index),
            mark,
            ...state.marks.slice(index + 1)
          ],
          showError: false
        }))
      )
    }
    this.setState({ showError: true })
  }

  handleMarkDelete = mark => {
    const { marks } = this.state

    return this.props
      .removeMark(mark.id)
      .then(() =>
        this.setState({ marks: marks.filter(_mark => _mark.id !== mark.id) })
      )
  }

  handleMarkAdd = () => {
    this.setState({ addMarkRow: true })
  }

  cancelMark = () => {
    this.setState({ addMarkRow: false, showError: false })
  }

  handleNewMarkSave = mark => {
    const { marks } = this.state
    const {
      response: { id: responseId }
    } = this.props

    if (mark.text.trim()) {
      return this.props.addMark({ ...mark, responseId }).then(({ data }) =>
        this.setState({
          addMarkRow: false,
          marks: [
            ...marks,
            {
              id: parseInt(data.id, 0),
              text: data.attributes.text,
              secondsAfterStart: data.attributes.seconds_after_start
            }
          ]
        })
      )
    }
    this.setState({ showError: true })
  }

  handleAlertClose = () => {
    this.setState({ showError: false })
  }

  render() {
    const { addMarkRow, showError } = this.state
    const { response, playerId } = this.props
    const { marks } = this.state
    const video = findEnglishVideo(response.languages) || response.video
    const { jsonTimestamps = [] } = video.videoTranscript || {}

    return (
      <div>
        <VideoContainer
          ref={ref => {
            this.video = ref ? ref.getWrappedInstance().getVideo() : null
          }}
          id={playerId}
          src={video.src}
          width="auto"
          height={480}
          options={{ languages: decamelizeKeys(response.languages) }}
          controlBar={{ languageMenu: {} }}
          closedCaption={true}
          captionSource={video.captionUrl}
          listeners={{
            timeupdate: e => scrollOnTimeUpdateWithFeatures(e, jsonTimestamps)
          }}
        />
        <TabList>
          <TabPanel title="Transcript">{this.getTranscript()}</TabPanel>
          <TabPanel title="Marks">
            <Button
              className="qv-button qv-button-create qv-button-small marginBottom10"
              onClick={this.handleMarkAdd}
            >
              <i className="im-icon-tags"></i>
              Add
            </Button>
            <div className="marks-viewer">
              {showError && (
                <MarkAlert
                  message="Mark Name: This is a mandatory field, can't be blank"
                  onCloseAlert={this.handleAlertClose}
                />
              )}

              {addMarkRow && (
                <MarkRow
                  handleClick={this.handleMarkClick}
                  onSave={this.handleNewMarkSave}
                  videoLength={response.video.length}
                  onCancel={this.cancelMark}
                  mark={{
                    secondsAfterStart: this.video.currentTime(),
                    text: ''
                  }}
                />
              )}
              <MarksList
                marks={marks}
                handleMarkClick={c => this.handleMarkClick(c)}
                onMarkSave={this.handleMarkUpdate}
                onMarkDelete={this.handleMarkDelete}
                videoLength={response.video.length}
              />
            </div>
          </TabPanel>
        </TabList>
      </div>
    )
  }
}

export default connect(
  null,
  { addMark, updateMark, removeMark }
)(VideoResponseMain)



// WEBPACK FOOTER //
// ../src/components/VideoResponseMain.js